<template>
  <div
    class="flex p-4 lg:mx-0 rounded-md w-full"
    :class="{
      [styleHorizontal]: alignment === 'horizontal',
      [styleVertical]: alignment === 'vertical'
    }"
  >
    <slot name="heading" />
    <slot name="content" />
    <slot name="cta" />
  </div>
</template>

<script setup>
  defineProps({
    alignment: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value)
    }
  });
  const styleHorizontal = 'flex-col lg:flex-row justify-between items-center';
  const styleVertical = 'flex-col gap-4 justify-between items-start';
</script>
